import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

// components
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component'
import DeleteObjectWithModal from '../../../blockGroups/deletion/DeleteObjectWithModal/DeleteObjectWithModal.blockgroup'

// collections
import EquipmentName from './collections/EquipmentName/EquipmentName.collection'
import EquipmentQuantity from './collections/EquipmentQuantity/EquipmentQuantity.collection'
import EquipmentSpecifications from './collections/EquipmentSpecifications/EquipmentSpecifications.collection'
import EquipmentDescription from './collections/EquipmentDescription/EquipmentDescription.collection'
import EquipmentLogs from './collections/EquipmentLogs/EquipmentLogs.collection'

// forms
import EditEquipmentFormController from './forms/EditEquipment.form.controllers'
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// apollo
import { GET_EQUIPMENT_BY_ID_WITH_LOGS, GET_ALL_EQUIPMENT_WITH_FULL_DETAIL } from '../../../graphql/equipment/equipment.queries'
import { DELETE_EQUIPMENT } from '../../../graphql/equipment/equipment.mutations'

// mui
import { Grid, Container } from '@mui/material'

// utils
import { createUserGroupList, checkIfUserHasGroup } from '../../../shared/privileges/userGroups'

export default function EquipmentDetail({ ...pageProps }) {

    const {equipmentId: equipmentIdParam} = useParams()
    const equipmentId = parseInt(equipmentIdParam)

    // user groups
    const groups = createUserGroupList(pageProps.usersGroups)

    // modals
    const [showEdit, setShowEdit] = useState(false)

    return (<div id="EquipmentDetail">
        <EditEquipmentFormController 
            id={equipmentId}
            visible={showEdit}
            closeForm={() => setShowEdit(false)}
        />

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}><EquipmentName id={equipmentId} /></Grid>
                {
                    checkIfUserHasGroup(groups, ['Admin']) && <Grid item xs={6} textAlign='right'><ActionButton label="Edit" onClick={() => setShowEdit(true)}/></Grid>
                }
                
            </Grid>
        </Container>

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container>
                <Grid item><EquipmentQuantity id={equipmentId} /></Grid>
            </Grid>
        </Container>
        
        <Container maxWidth={false} disableGutters>
            <Grid container spacing={2} justifyContent='space-between'>
                <Grid item xs={6}><EquipmentSpecifications id={equipmentId} /></Grid>
                <Grid item xs={6}><EquipmentDescription id={equipmentId} /></Grid>
            </Grid>
        </Container>

        <WithGqlQuery component={EquipmentLogs} query={GET_EQUIPMENT_BY_ID_WITH_LOGS} variables={{ id: equipmentId }} />

        {
            checkIfUserHasGroup(groups, ['Admin']) && 
            <DeleteObjectWithModal 
                id={equipmentId}
                mutation={DELETE_EQUIPMENT}
                deleteLabel={"Delete Equipment"}
                deleteTitle={"Delete Equipment"}
                deleteMessage={"Are you sure you want to delete this Equipment item? This will delete all Inventory Logs, Equipment Request Items, and Purchase Order Items associated with this Equipment item."}
                successObjectKey="deleteEquipment"
                entityName="Equipment"
            />
        }
        
        
    </div>)
}